import uuid from 'node-uuid'
import moment from 'moment'
import {apiUrl, apiOption, apiResponse, errorResponse, only} from '../core/fetchz'
import loading from '../core/redux/loading'
import config from '../config'

const NAMESPACE = 'Satisfaction'
export const CAMPAIGN_LINKS_LOADED = NAMESPACE + '/CampaignLinksLoaded'
export const CAMPAIGN_STREAM_LOADED = NAMESPACE + '/CampaignStreamLoaded'
export const CAMPAIGN_LOADED = NAMESPACE + '/CampaignLoaded'
export const CAMPAIGN_QUERIED = NAMESPACE + '/CampaignQueried'
export const ANSWER_STREAM_LOADED = NAMESPACE + '/AnswerStreamLoaded'
export const ANSWER_STREAM_QUERIED = NAMESPACE + '/AnswerStreamQueried'
export const CREATE_CAMPAIGN_ACTION_SENT = NAMESPACE + '/CreateCampaignActionSent'
export const UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT = NAMESPACE + '/UpdateNotationScaleOfCampaignActionSent'
export const UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT = NAMESPACE + '/UpdateTitleOfCampaignActionSent'
export const ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT = NAMESPACE + '/AddQuestionToCampaignActionSent'
export const REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT = NAMESPACE + '/RemoveQuestionFromCampaignActionSent'
export const DEFINE_ANSWER_RATE_GOAL_ACTION_SENT = NAMESPACE + '/DefineAnswerRateGoalActionSent'
export const START_CAMPAIGN_ACTION_SENT = NAMESPACE + '/StartCampaignActionSent'
export const FINISH_CAMPAIGN_ACTION_SENT = NAMESPACE + '/FinishCampaignActionSent'
export const ANSWER_ACTION_SENT = NAMESPACE + '/AnswerActionSent'
// form actions
export const CREATE_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/CreateCampaignActionUpdated'
export const UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/UpdateNotationScaleOfCampaignActionUpdated'
export const UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/UpdateTitleOfCampaignActionUpdated'
export const ADD_QUESTION_TO_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/AddQuestionToCampaignActionUpdated'
export const DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED = NAMESPACE + '/DefineAnswerRateGoalActionUpdated'
export const START_CAMPAIGN_ACTION_UPDATED = NAMESPACE + '/StartCampaignActionUpdated'
export const ANSWER_ACTION_UPDATED = NAMESPACE + '/AnswerActionUpdated'

export const DEFAULT_QUERY = {
    range: {offset: 0, limit: 19}
}

export const DEFAULT_CAMPAIGN_QUERY = {
    companyUid: null
}

export const DEFAULT_ANSWER_QUERY = {
    ...DEFAULT_QUERY,
    companyUid: null,
    campaignUid: null,
    ticketUid: null
}

export function loadCampaignLinks() {
    const query = {
        range: {offset: 0, limit: 0}
    }

    return loading(fetch(apiUrl(config.api.url + '/satisfactioncampaigns', query), apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: CAMPAIGN_LINKS_LOADED,
            _links: json._links
        }
    }), CAMPAIGN_LINKS_LOADED)
}

export function loadCampaignStream(campaignQuery) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.satisfaction.campaign

        campaignQuery = {
            ...DEFAULT_CAMPAIGN_QUERY,
            companyUid: company && company.uid,
            ...query,
            ...campaignQuery
        }

        const {companyUid, ...apiCampaignQuery} = campaignQuery

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + companyUid + '/satisfactioncampaigns', apiCampaignQuery), apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CAMPAIGN_STREAM_LOADED,
                stream: json.result,
                _links: json._links,
                query: campaignQuery
            }
        })
    }, CAMPAIGN_STREAM_LOADED)
}

export function queryCampaign(companyId, campaignId) {
    return loadCampaign(companyId, campaignId, CAMPAIGN_QUERIED)
}

export function loadCampaign(companyId, campaignId, action) {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        companyId = companyId || (campaign && campaign.company.uid)
        campaignId = campaignId || (campaign && campaign.uid)

        return fetch(config.api.url + '/clientcompanies/' + companyId + '/satisfactioncampaigns/' + campaignId, apiOption())
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: action || CAMPAIGN_LOADED,
                campaign: json
            }
        })
    }, action || CAMPAIGN_LOADED)
}

export function queryActiveCampaign(companyId) {
    return loadActiveCampaign(companyId, CAMPAIGN_QUERIED)
}

export function loadActiveCampaign(companyId, action) {
    return loading(fetch(config.api.url + '/clientcompanies/' + companyId + '/satisfactioncampaigns/active', apiOption())
    .then(apiResponse)
    .then(({json}) => {
        return {
            type: action || CAMPAIGN_LOADED,
            campaign: json
        }
    })
    .catch(only([403, 404], (error) => {
        return {
            type: action || CAMPAIGN_LOADED,
            campaign: null
        }
    })), action || CAMPAIGN_LOADED)
}

export function queryAnswerStream(answerQuery, action) {
    return loadAnswerStream(answerQuery, ANSWER_STREAM_QUERIED)
}

export function loadAnswerStream(answerQuery, action) {
    return loading((state) => {
        const {company} = state.company
        const {query} = state.satisfaction.answer

        answerQuery = {
            ...DEFAULT_ANSWER_QUERY,
            companyUid: company && company.uid,
            ...query,
            ...answerQuery
        }

        const {companyUid, ...apiAnswerQuery} = answerQuery

        return fetch(apiUrl(config.api.url + '/clientcompanies/' + companyUid + '/satisfactioncampaignanswers', apiAnswerQuery), apiOption())
        .then(apiResponse)
        .then(({headers, json}) => {
            return {
                type: action || ANSWER_STREAM_LOADED,
                stream: json.result,
                range: headers.contentRange,
                query: answerQuery
            }
        })
    }, action || ANSWER_STREAM_LOADED)
}

export function sendCreateCampaignAction() {
    return loading((state) => {
    	const {company} = state.company
        const {createCampaignAction} = state.satisfaction

        const option = {
            method: 'PATCH',
            body: {
                action: 'CreateCampaign',
                ...createCampaignAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(apiResponse)
        .then(({json}) => {
            return {
                type: CREATE_CAMPAIGN_ACTION_SENT,
                satisfactionCampaignUid: json.satisfactionCampaignUid
            }
        })
    }, CREATE_CAMPAIGN_ACTION_SENT)
}

export function sendUpdateNotationScaleOfCampaignAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {updateNotationScaleOfCampaignAction} = state.satisfaction

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateNotationScaleOfCampaign',
                campaignUid: campaign.uid,
                ...updateNotationScaleOfCampaignAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT
            }
        })
    }, UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_SENT)
}

export function sendUpdateTitleOfCampaignAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {updateTitleOfCampaignAction} = state.satisfaction

        const option = {
            method: 'PATCH',
            body: {
                action: 'UpdateTitleOfCampaign',
                campaignUid: campaign.uid,
                ...updateTitleOfCampaignAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT
            }
        })
    }, UPDATE_TITLE_OF_CAMPAIGN_ACTION_SENT)
}

export function sendAddQuestionToCampaignAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {addQuestionToCampaignAction} = state.satisfaction

        const option = {
            method: 'PATCH',
            body: {
                action: 'AddQuestionToCampaign',
                campaignUid: campaign.uid,
                ...addQuestionToCampaignAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT
            }
        })
    }, ADD_QUESTION_TO_CAMPAIGN_ACTION_SENT)
}

export function sendRemoveQuestionFromCampaignAction(questionId) {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign

        const option = {
            method: 'PATCH',
            body: {
                action: 'RemoveQuestionFromCampaign',
                campaignUid: campaign.uid,
                questionUid: questionId
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT
            }
        })
    }, REMOVE_QUESTION_FROM_CAMPAIGN_ACTION_SENT)
}

export function sendDefineAnswerRateGoalAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {defineAnswerRateGoalAction} = state.satisfaction

        const option = {
            method: 'PATCH',
            body: {
                action: 'DefineAnswersRateGoal',
                campaignUid: campaign.uid,
                ...defineAnswerRateGoalAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: DEFINE_ANSWER_RATE_GOAL_ACTION_SENT
            }
        })
    }, DEFINE_ANSWER_RATE_GOAL_ACTION_SENT)
}

export function sendStartCampaignAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {startCampaignAction} = state.satisfaction
        const {elligibleCreateTicketDate, ...action} = startCampaignAction

        const option = {
            method: 'PATCH',
            body: {
                action: 'StartCampaign',
                campaignUid: campaign.uid,
                elligibleCreateTicketDate: moment(elligibleCreateTicketDate).format('YYYY-MM-DD'),
                ...action
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: START_CAMPAIGN_ACTION_SENT
            }
        })
    }, START_CAMPAIGN_ACTION_SENT)
}

export function sendFinishCampaignAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign

        const option = {
            method: 'PATCH',
            body: {
                action: 'FinishCampaign',
                campaignUid: campaign.uid
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaigns', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: FINISH_CAMPAIGN_ACTION_SENT
            }
        })
    }, FINISH_CAMPAIGN_ACTION_SENT)
}

export function sendAnswerAction() {
    return loading((state) => {
        const {campaign} = state.satisfaction.campaign
        const {answerAction} = state.satisfaction

        const option = {
            body: {
                action: 'Answer',
                campaignUid: campaign.uid,
                ...answerAction
            }
        }

        return fetch(config.api.url + '/clientcompanies/' + campaign.company.uid + '/satisfactioncampaignanswers', apiOption(option))
        .then(errorResponse)
        .then(() => {
            return {
                type: ANSWER_ACTION_SENT
            }
        })
    }, ANSWER_ACTION_SENT)
}

export function updateCreateCampaignAction(action) {
    return {
        type: CREATE_CAMPAIGN_ACTION_UPDATED,
        action: action
    }
}

export function updateUpdateNotationScaleOfCampaignAction(action) {
    return {
        type: UPDATE_NOTATION_SCALE_OF_CAMPAIGN_ACTION_UPDATED,
        action: action
    }
}

export function updateUpdateTitleOfCampaignAction(action) {
    return {
        type: UPDATE_TITLE_OF_CAMPAIGN_ACTION_UPDATED,
        action: action
    }
}

export function updateDefineAnswerRateGoalAction(action) {
    return {
        type: DEFINE_ANSWER_RATE_GOAL_ACTION_UPDATED,
        action: action
    }   
}

export function updateAnswerAction(action) {
    return {
        type: ANSWER_ACTION_UPDATED,
        action: action
    }
}


// WEBPACK FOOTER //
// ./lib/satisfaction/actions.js